import { useUserStore } from '@/config/store/userStore'
import { isModuleActive } from '@/services/application'
import {
  hasAnyTimesheetSettingsAccess,
  hasTimesheetSettingAccess,
  type TimesheetSettingAccessKey,
} from '@/services/timesheet/settingsAccess'

const moduleId = 20

const canUserAccessModule = (user) => {
  const isFirmAccess = isModuleActive(user.firm, moduleId)
  return isFirmAccess && user.profile.modules.timesheet.isAccess
}

export const guardTimesheetAccess = () => {
  const userStore = useUserStore()
  const user = userStore.user
  const canAccess = canUserAccessModule(user)
  return canAccess || { name: 'Home' }
}

export const guardTimesheetSettingsAccess = () => {
  const userStore = useUserStore()
  const user = userStore.user
  return hasAnyTimesheetSettingsAccess(user.profile.modules.timesheet) || { name: 'Home' }
}

export const guardTimesheetSettingAccess = (key: TimesheetSettingAccessKey) => {
  const userStore = useUserStore()
  const user = userStore.user
  return hasTimesheetSettingAccess(user.profile.modules.timesheet, key) || { name: 'Home' }
}
